/**
 * src/shell/ui/screens/NewProjectScreen.tsx — S6 立项屏（设计稿 §1.2 S6 / §2 Phase 2）。
 * 一段话 idea + 团队自动成队确认 + 成本预估（运行时读 market 参数）+ 提交。
 */

import { useEffect, useState } from 'react'
import { COPY } from '../../copy'
import { createProject, estimateCost, teamReadiness, type TeamReadiness } from '../../gm-client/actions'
import type { Screen } from '../nav'

const C = COPY.newProject

export function NewProjectScreen({ go }: { go: (s: Screen) => void }) {
  const [idea, setIdea] = useState('')
  const [team, setTeam] = useState<TeamReadiness | null>(null)
  const [cost, setCost] = useState<{ coins: number; tokens: number } | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    void teamReadiness().then(setTeam)
  }, [])

  useEffect(() => {
    if (team?.ok) void estimateCost(team.team).then(setCost)
    else setCost(null)
  }, [team])

  return (
    <div className="screen deep-screen">
      <button className="btn back-btn" type="button" onClick={() => go({ name: 'computer', tab: 'projects' })}>
        {COPY.nav.back}
      </button>
      <div className="panel">
        <h3>{C.title}</h3>
        <label className="form-label">{C.ideaLabel}</label>
        <textarea
          className="text-area"
          rows={4}
          value={idea}
          onChange={(e) => setIdea(e.target.value)}
          placeholder={C.ideaPlaceholder}
        />

        <h4>{C.teamTitle}</h4>
        {team === null ? (
          <p className="dim">…</p>
        ) : team.ok ? (
          <ul>
            {team.members.map((m) => (
              <li key={m.id}>
                {m.name} · {m.role} · <span className={`badge rarity-${m.rarity}`}>{m.rarity}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="graybox graybox-warn">
            {C.teamMissing}（{team.missing.join(' / ')}）
            <button className="btn btn-small" type="button" onClick={() => go({ name: 'phone', dept: 'hr' })}>
              {COPY.phone.hr}
            </button>
          </p>
        )}

        {cost && (
          <p className="dim mono">
            {C.costEstimate} {cost.coins} 金币 · {C.tokenEstimate} ≈{cost.tokens}
          </p>
        )}

        <button
          className="btn btn-primary"
          type="button"
          disabled={busy || !team?.ok || !idea.trim()}
          onClick={() => {
            setBusy(true)
            void createProject(idea).then((p) => {
              setBusy(false)
              if (p) go({ name: 'computer', tab: 'projects', projectId: p.id })
            })
          }}
        >
          {C.submit}
        </button>
      </div>
    </div>
  )
}
